import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './embalagemViagemForm';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import Aguardando from '../common/template/aguardando';
import Select from '../common/form/select';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import InputPesquisa from '../common/form/inputPesquisa';
import ReactExport from 'react-export-excel-fixed-xlsx';

import {
	setModoTela, setFiltro, initForm, salvar, excluir, getLista, finalizar, reabrir, gerarComprovanteEntrega, gerarPackingList,
	setModoTelaItem, initFormItem, salvarItem, excluirItem, getListaItem, getListaHistorico,
	getListaFornecedor, getListaEmbalagem, getListaPlanoCarga, getListaEstoqueLocal, getListaSentido, getListaStatus, getListaTransportadora, getListaEmbalagemViagemEventoTipo } from './embalagemViagemActions';
import { getLista as getListaCliente } from '../cliente/clienteActions';

class EmbalagemViagem extends Component {

	state = {
		pesquisar: '',
		linhaSelecionada: null,
		ordenacao: {
			datahora_viagem: 1
		}
	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaTransportadora();
		this.props.getListaCliente();
		this.props.getListaFornecedor();
		this.props.getListaEmbalagem();
		this.props.getListaPlanoCarga();
		this.props.getListaEstoqueLocal();
		this.props.getListaSentido();
		this.props.getListaStatus();
		this.props.getListaEmbalagemViagemEventoTipo();
    }

    render() {
        return (
            <div>
                <Content>

					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'visualizacao' ? (
						<Form onSubmit={() => {}} visualizacao />
					) : null}
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	filtrar() {

		const lista = this.props.lista.filter(item => {

			if (this.props.filtro.sentido_fornecedor_cliente && this.props.filtro.sentido_cliente_fornecedor) {
				//continue
			} else if (this.props.filtro.sentido_fornecedor_cliente && item.id_origem == 2) {
				//continue
			} else if (this.props.filtro.sentido_cliente_fornecedor && item.id_origem == 1) {
				//continue
			} else {
				return false;
			}

			if (this.props.filtro.id_evento && item.id_ultimo_evento != this.props.filtro.id_evento) {
				return false;
			}

			if (this.props.filtro.id_tipo_embalagem && item.id_tipo_embalagem != this.props.filtro.id_tipo_embalagem) {
				return false;
			}

			return true;
		}).filter(item => {
			return !(this.state.pesquisar || '').trim()
				|| (this.state.pesquisar.toUpperCase() || '').split('+').filter(pesquisar => (pesquisar || '').trim()).filter(pesquisar => {
					if (pesquisar
						&& !(`
							${DateFormat.formatarDataHoraSqlParaTela(item.datahora_viagem)} ${item.nome_transportadora} ${item.nome_status} ${item.viagem} ${item.solicitacao}
							${item.fatura} ${item.conhecimento_transporte || ''} ${item.mic || ''} ${item.carga_manual || ''} ${item.cavalo || ''} ${item.carreta1 || ''} ${item.carreta2 || ''}
							${item.nome_origem}	${item.nome_fornecedor_origem} ${item.nome_destino}	${item.nome_fornecedor_destino} ${item.ultimo_evento}
						`).toUpperCase().includes(pesquisar)) {
						return false;
					}
					return true;
				}).length > 0;
		});

		if (this.state.ordenacao.datahora_viagem) {
			lista.sort((a, b) => this.getOrdem(a.datahora_viagem, b.datahora_viagem, this.state.ordenacao.datahora_viagem));
		} else if (this.state.ordenacao.nome_transportadora) {
			lista.sort((a, b) => this.getOrdem((a.nome_transportadora || ''), (b.nome_transportadora || ''), this.state.ordenacao.nome_transportadora));
		} else if (this.state.ordenacao.nome_status) {
			lista.sort((a, b) => this.getOrdem((a.ativo ? a.nome_status : 'Cancelada'), (b.ativo ? b.nome_status : 'Cancelada'), this.state.ordenacao.nome_status));
		} else if (this.state.ordenacao.viagem) {
			lista.sort((a, b) => this.getOrdem((a.viagem || ''), (b.viagem || ''), this.state.ordenacao.viagem));
		} else if (this.state.ordenacao.solicitacao) {
			lista.sort((a, b) => this.getOrdem((a.solicitacao || ''), (b.solicitacao || ''), this.state.ordenacao.solicitacao));
		} else if (this.state.ordenacao.fatura) {
			lista.sort((a, b) => this.getOrdem((a.fatura || ''), (b.fatura || ''), this.state.ordenacao.fatura));
		} else if (this.state.ordenacao.conhecimento_transporte) {
			lista.sort((a, b) => this.getOrdem((a.conhecimento_transporte || ''), (b.conhecimento_transporte || ''), this.state.ordenacao.conhecimento_transporte));
		} else if (this.state.ordenacao.mic) {
			lista.sort((a, b) => this.getOrdem((a.mic || ''), (b.mic || ''), this.state.ordenacao.mic));
		} else if (this.state.ordenacao.carga_manual) {
			lista.sort((a, b) => this.getOrdem((a.carga_manual || ''), (b.carga_manual || ''), this.state.ordenacao.carga_manual));
		} else if (this.state.ordenacao.cavalo) {
			lista.sort((a, b) => this.getOrdem((a.cavalo || ''), (b.cavalo || ''), this.state.ordenacao.cavalo));
		} else if (this.state.ordenacao.carreta) {
			lista.sort((a, b) => this.getOrdem(`${a.carreta1 || ''}${a.carreta2 ? ', ' : ''}${a.carreta2 || ''}`, `${b.carreta1 || ''}${b.carreta2 ? ', ' : ''}${b.carreta2 || ''}`, this.state.ordenacao.carreta));
		} else if (this.state.ordenacao.nome_fornecedor_origem) {
			lista.sort((a, b) => this.getOrdem((a.nome_fornecedor_origem || a.nome_cliente), (b.nome_fornecedor_origem || b.nome_cliente), this.state.ordenacao.nome_fornecedor_origem));
		} else if (this.state.ordenacao.nome_fornecedor_destino) {
			lista.sort((a, b) => this.getOrdem((a.nome_fornecedor_destino || a.nome_cliente), (b.nome_fornecedor_destino || b.nome_cliente), this.state.ordenacao.nome_fornecedor_destino));
		} else if (this.state.ordenacao.ultimo_evento) {
			lista.sort((a, b) => this.getOrdem((a.ultimo_evento || ''), (b.ultimo_evento || ''), this.state.ordenacao.ultimo_evento));
		}

		return lista;

	}

	getOrdem(itemA, itemB, tipo) {

		return tipo == 1 
			? (itemA > itemB ? 1 : -1) 
			: (itemA > itemB ? -1 : 1);

	}

	setNovaOrdenacao(atual) {		
		this.setState({
			ordenacao: {
				...atual
			}
		});
	}

	getNovaOrdenacao(atual) {
		return atual == 2 ? 0 : (atual || 0) + 1;
	}

	getIconeOrdenacao(tipo) {
		if (tipo == 1) {
			return <i class="fas fa-sort-amount-down-alt" />;
		} else if (tipo == 2) {
			return <i class="fas fa-sort-amount-up" />;
		} else {
			return null;
		}
	}

	lista() {

		let setLinhaSelecionada = (id) => {
			this.setState({
				...this.state,
				linhaSelecionada: id
			});
		}

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row alignCenter>
						<InputPesquisa
							cols='12 6 3 1'
							label='Pesquisar'
							minWidth={344}
							onChange={value => this.setState({ ...this.state, pesquisar: value })} />

						<LabelAndInputMask
							label='Data/Hora' placeholder='Informe o período inicial'
							cols='12 6 3 2'
							mask='99/99/9999'
							width={130}
							value={this.props.filtro.data_inicial}
							onChange={(data) => {
								this.props.setFiltro({ ...this.props.filtro, data_inicial: data.target.value });
								this.props.getLista();
							}} />

						<LabelAndInputMask
							label='Data/Hora' placeholder='Informe o período final'
							cols='12 6 3 2'
							mask='99/99/9999'
							width={130}
							value={this.props.filtro.data_final}
							onChange={(data) => {
								this.props.setFiltro({ ...this.props.filtro, data_final: data.target.value });
								this.props.getLista();
							}} />

						<Select
							options={this.props.listaEventoTipo}
							label='Evento'
							cols='12 6 3 3'
							maxWidth={260}
							placeholder='Selecione o evento'
							value={this.props.filtro.id_evento}
							onChange={data => {
								this.props.setFiltro({ ...this.props.filtro, id_evento: data });
							}} />

						<div style={{ marginTop: 8, width: 270  }}>
							<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.setModoTela('cadastro', {
										datahora_viagem: DateFormat.formatarDataHoraSqlParaTela(DateFormat.getDataHoraAtual()),
										id_transportadora: this.props.sessao.id_transportadora
									});
									this.props.initForm({
										datahora_viagem: DateFormat.formatarDataHoraSqlParaTela(DateFormat.getDataHoraAtual()),
										id_transportadora: this.props.sessao.id_transportadora
									});
									this.props.getListaItem(0);
									this.props.getListaHistorico(0);
									this.props.setModoTelaItem('lista');
								}}>
								<i class='fas fa-plus'></i> Adicionar
							</a>
							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.getLista();
								}}>
								<i class='fas fa-sync-alt'></i> Atualizar
							</a>
							<ExcelFile
									filename={'Viagens'}
									element={
										<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}>
											<i class='fas fa-file-excel'></i> Exportar
										</a>
									}>
									{this.montarExcel(this.filtrar())}													
								</ExcelFile>
						</div>															
					</Row>

					<Row>
						<Grid cols='12 12 12 12'>
							<div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', marginBottom: 4 }}>

								<div class={`filter-chip ${this.props.filtro.aberta ? 'active' : ''}`}
									onClick={() => {
										this.props.setFiltro({ ...this.props.filtro, aberta: !this.props.filtro.aberta });
										this.props.getLista();
									}}>
									<i class='fas fa-boxes'></i> Abertas
								</div>

								<div class={`filter-chip ${this.props.filtro.fechada ? 'active' : ''}`}
									onClick={() => {
										this.props.setFiltro({ ...this.props.filtro, fechada: !this.props.filtro.fechada });
										this.props.getLista();
									}}>
									<i class='fas fa-boxes'></i> Finalizadas
								</div>
						
								<div class={`filter-chip ${this.props.filtro.cancelada ? 'active' : ''}`}
									onClick={() => {
										this.props.setFiltro({ ...this.props.filtro, cancelada: !this.props.filtro.cancelada });
										this.props.getLista();
									}}>
									<i class='fas fa-boxes'></i> Canceladas
								</div>
								
								<div class={`filter-chip ${this.props.filtro.sentido_fornecedor_cliente ? 'active' : ''}`}
									onClick={() => {
										this.props.setFiltro({ ...this.props.filtro, sentido_fornecedor_cliente: !this.props.filtro.sentido_fornecedor_cliente });
										this.props.getLista();
									}}>
									<i class='fas fa-boxes'></i> {`Fornecedor > Cliente`}
								</div>

								<div class={`filter-chip ${this.props.filtro.sentido_cliente_fornecedor ? 'active' : ''}`}
									onClick={() => {
										this.props.setFiltro({ ...this.props.filtro, sentido_cliente_fornecedor: !this.props.filtro.sentido_cliente_fornecedor });
										this.props.getLista();
									}}>
									<i class='fas fa-boxes'></i> {`Cliente > Fornecedor`}
								</div>
							</div>
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<Table responsive border alturaFixa striped
						maxHeight={window.innerWidth < 731 ? '100%' : (
							window.innerWidth < 1401 ? window.innerHeight - 300 : window.innerHeight - 220
						)}>
						<THead>
							<Tr backgroundColor={'#1F3066'} color={'#ffffff'}>
								<Th sticky alignCenter width={100} backgroundColor={'#1F3066'} color={'#ffffff'} onClick={() => this.setNovaOrdenacao({ datahora_viagem: this.getNovaOrdenacao(this.state.ordenacao.datahora_viagem)})}>Data/Hora {this.getIconeOrdenacao(this.state.ordenacao.datahora_viagem)}</Th>
								<Th sticky alignCenter width={100} backgroundColor={'#1F3066'} color={'#ffffff'} onClick={() => this.setNovaOrdenacao({ nome_transportadora: this.getNovaOrdenacao(this.state.ordenacao.nome_transportadora)})}>Transportadora {this.getIconeOrdenacao(this.state.ordenacao.nome_transportadora)}</Th>
								<Th sticky alignCenter width={100} backgroundColor={'#1F3066'} color={'#ffffff'} onClick={() => this.setNovaOrdenacao({ nome_status: this.getNovaOrdenacao(this.state.ordenacao.nome_status)})}>Status {this.getIconeOrdenacao(this.state.ordenacao.nome_status)}</Th>
								<Th sticky alignCenter width={100} backgroundColor={'#1F3066'} color={'#ffffff'} onClick={() => this.setNovaOrdenacao({ viagem: this.getNovaOrdenacao(this.state.ordenacao.viagem)})}>Viagem {this.getIconeOrdenacao(this.state.ordenacao.viagem)}</Th>
								<Th sticky alignCenter width={100} backgroundColor={'#1F3066'} color={'#ffffff'} onClick={() => this.setNovaOrdenacao({ solicitacao: this.getNovaOrdenacao(this.state.ordenacao.solicitacao)})}>Solicitação {this.getIconeOrdenacao(this.state.ordenacao.solicitacao)}</Th>
								<Th sticky alignCenter width={100} backgroundColor={'#1F3066'} color={'#ffffff'} onClick={() => this.setNovaOrdenacao({ fatura: this.getNovaOrdenacao(this.state.ordenacao.fatura)})}>Fatura {this.getIconeOrdenacao(this.state.ordenacao.fatura)}</Th>
								<Th sticky alignCenter width={100} backgroundColor={'#1F3066'} color={'#ffffff'} onClick={() => this.setNovaOrdenacao({ conhecimento_transporte: this.getNovaOrdenacao(this.state.ordenacao.conhecimento_transporte)})}>CRT {this.getIconeOrdenacao(this.state.ordenacao.conhecimento_transporte)}</Th>
								<Th sticky alignCenter width={100} backgroundColor={'#1F3066'} color={'#ffffff'} onClick={() => this.setNovaOrdenacao({ mic: this.getNovaOrdenacao(this.state.ordenacao.mic)})}>MIC {this.getIconeOrdenacao(this.state.ordenacao.mic)}</Th>
								<Th sticky alignCenter width={100} backgroundColor={'#1F3066'} color={'#ffffff'} onClick={() => this.setNovaOrdenacao({ carga_manual: this.getNovaOrdenacao(this.state.ordenacao.carga_manual)})}>Embarque GMA {this.getIconeOrdenacao(this.state.ordenacao.carga_manual)}</Th>
								<Th sticky alignCenter width={100} backgroundColor={'#1F3066'} color={'#ffffff'} onClick={() => this.setNovaOrdenacao({ cavalo: this.getNovaOrdenacao(this.state.ordenacao.cavalo)})}>Cavalo {this.getIconeOrdenacao(this.state.ordenacao.cavalo)}</Th>
								<Th sticky alignCenter width={100} backgroundColor={'#1F3066'} color={'#ffffff'} onClick={() => this.setNovaOrdenacao({ carreta: this.getNovaOrdenacao(this.state.ordenacao.carreta)})}>Carretas {this.getIconeOrdenacao(this.state.ordenacao.carreta)}</Th>
								<Th sticky alignCenter width={100} backgroundColor={'#1F3066'} color={'#ffffff'} onClick={() => this.setNovaOrdenacao({ nome_fornecedor_origem: this.getNovaOrdenacao(this.state.ordenacao.nome_fornecedor_origem)})}>Origem {this.getIconeOrdenacao(this.state.ordenacao.nome_fornecedor_origem)}</Th>
								<Th sticky alignCenter width={100} backgroundColor={'#1F3066'} color={'#ffffff'} onClick={() => this.setNovaOrdenacao({ nome_fornecedor_destino: this.getNovaOrdenacao(this.state.ordenacao.nome_fornecedor_destino)})}>Destino {this.getIconeOrdenacao(this.state.ordenacao.nome_fornecedor_destino)}</Th>
								<Th sticky alignCenter width={200} backgroundColor={'#1F3066'} color={'#ffffff'} onClick={() => this.setNovaOrdenacao({ ultimo_evento: this.getNovaOrdenacao(this.state.ordenacao.ultimo_evento)})}>Último Status {this.getIconeOrdenacao(this.state.ordenacao.ultimo_evento)}</Th>
								<Th sticky alignCenter width={130} backgroundColor={'#1F3066'} color={'#ffffff'}></Th>
							</Tr>
						</THead>
						<TBody>
							{this.filtrar().map((item, i) => (
								<Tr key={i} 
									backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')} >
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_viagem)}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.nome_transportadora}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.ativo ? item.nome_status : 'Cancelada'}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.viagem}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.solicitacao}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.fatura}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.conhecimento_transporte || ''}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.mic || ''}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.carga_manual || ''}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.cavalo || ''}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.carreta1 || ''}{item.carreta2 ? ', ' : ''}{item.carreta2 || ''}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.nome_fornecedor_origem || item.nome_cliente}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.nome_fornecedor_destino || item.nome_cliente}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.ultimo_evento || ''}</Td>
									<Td alignCenter minWidth={130}>
										<div>
											<ButtonTable
												type={'primary'}
												width={32}
												small
												icon={'fas fa-eye'}
												visible={true}
												title='Visualizar'
												event={() => {
													this.props.setModoTela('visualizacao', {
														...item,
														datahora_viagem: DateFormat.formatarDataHoraSqlParaTela(item.datahora_viagem),
														datahora_finalizacao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_finalizacao)
													});
													this.props.initForm({
														...item,
														datahora_viagem: DateFormat.formatarDataHoraSqlParaTela(item.datahora_viagem),
														datahora_finalizacao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_finalizacao)
													});

													this.props.getListaItem(item.id);
													this.props.getListaHistorico(item.id);
													this.props.setModoTelaItem('lista');
												}} />

											<ButtonTable
												type={'warning'}
												width={32}
												small
												icon={'fas fa-pencil-alt'}
												disabled={!item.ativo}
												visible={true}
												title='Editar'
												event={() => {
													this.props.setModoTela('cadastro', {
														...item,
														datahora_viagem: DateFormat.formatarDataHoraSqlParaTela(item.datahora_viagem),
														datahora_finalizacao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_finalizacao)
													});
													this.props.initForm({
														...item,
														datahora_viagem: DateFormat.formatarDataHoraSqlParaTela(item.datahora_viagem),
														datahora_finalizacao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_finalizacao)
													});

													this.props.getListaItem(item.id);
													this.props.setModoTelaItem('lista');
												}} />

											<ButtonTable
												type={'danger'}
												width={32}
												small
												icon={'fas fa-trash-alt'}
												visible={true}
												disabled={!item.ativo || item.id_status != 1}
												title='Cancelar'
												event={() => {
													this.props.setModoTela('exclusao', {
														...item,
														datahora_viagem: DateFormat.formatarDataHoraSqlParaTela(item.datahora_viagem),
														datahora_finalizacao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_finalizacao)
													});
													this.props.initForm({
														...item,
														datahora_viagem: DateFormat.formatarDataHoraSqlParaTela(item.datahora_viagem),
														datahora_finalizacao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_finalizacao)
													});

													this.props.getListaItem(item.id);
													this.props.setModoTelaItem('lista');
												}} />
										</div>
										<div style={{ marginTop: 4 }}>
											<ButtonTable
												type={'primary'}
												width={32}
												small
												icon={'fas fa-file-alt'}
												visible={true}
												title='Emitir comprovante de entrega'
												event={() => {
													this.props.gerarComprovanteEntrega(item.id);
												}} />

											{this.props.sessao && !this.props.sessao.modoCliente && !this.props.sessao.modoTransportadora && !this.props.sessao.modoFornecedor ? (
												<ButtonTable
													type={'primary'}
													width={32}
													small
													icon={'fas fa-file-invoice'}
													visible={true}
													title='Emitir Packing List'
													event={() => {
														this.props.gerarPackingList(item.id);
													}} />
											) : null}

											<ButtonTable
												type={'success'}
												width={32}
												small
												icon={`fas fa-${item.id_status == 1 ? 'check' : 'undo'}`}
												visible={true}
												disabled={item.id_status == 3}
												title={item.id_status == 1 ? 'Finalizar viagem' : 'Reabrir viagem'}
												event={() => {
													if (item.id_status == 1) {
														this.props.finalizar(item);
													} else if (item.id_status == 2) {
														this.props.reabrir(item);
													}
												}} />
										</div>
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}

	montarExcel(lista) {

		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		return (
			<ExcelSheet data={lista.map(item => ({
				...item,
				datahora_viagem: DateFormat.formatarDataHoraSqlParaTela(item.datahora_viagem),
				status: item.ativo ? item.nome_status : 'Cancelada',
				carretas: `${item.carreta1 || ''}${item.carreta2 ? ', ' : ''}${item.carreta2 || ''}`,
				nome_fornecedor_origem: item.nome_fornecedor_origem || item.nome_cliente,
				nome_fornecedor_destino: item.nome_fornecedor_destino || item.nome_cliente
			}))} name='Viagens'>
				{[
					{ componente: <ExcelColumn key={1} label='Data/Hora' value='datahora_viagem'/>},
					{ componente: <ExcelColumn key={2} label='Transportadora' value='nome_transportadora'/>},
					{ componente: <ExcelColumn key={3} label='Status' value='status'/>},
					{ componente: <ExcelColumn key={4} label='Viagem' value='viagem'/>},
					{ componente: <ExcelColumn key={5} label='Solicitação' value='solicitacao'/>},
					{ componente: <ExcelColumn key={6} label='Fatura' value='fatura'/>},
					{ componente: <ExcelColumn key={7} label='CRT' value='conhecimento_transporte'/>},
					{ componente: <ExcelColumn key={8} label='MIC' value='mic'/>},
					{ componente: <ExcelColumn key={9} label='Embarque GMA' value='carga_manual'/>},
					{ componente: <ExcelColumn key={10} label='Cavalo' value='cavalo'/>},
					{ componente: <ExcelColumn key={11} label='Carretas' value='carretas'/>},
					{ componente: <ExcelColumn key={12} label='Origem' value='nome_fornecedor_origem'/>},
					{ componente: <ExcelColumn key={13} label='Destino' value='nome_fornecedor_destino'/>},
					{ componente: <ExcelColumn key={14} label='Último Status' value='ultimo_evento'/>},
				].filter(item => {
					return true;
				}).map(item => (
					item.componente
				))}
			</ExcelSheet>
		);
	}
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	aguardando: state.embalagemViagem.aguardando,
	filtro: state.embalagemViagem.filtro,
	modoTela: state.embalagemViagem.modoTela,
	filtro: state.embalagemViagem.filtro,
	lista: state.embalagemViagem.lista,
	listaItem: state.embalagemViagem.listaItem,
	listaFornecedor: state.embalagemViagem.listaFornecedor,
	listaEmbalagem: state.embalagemViagem.listaEmbalagem,
	listaEstoqueLocal: state.embalagemViagem.listaEstoqueLocal,
	listaEventoTipo: state.embalagemViagem.listaEventoTipo,
	listaEmbalagemTipo: state.embalagem.listaTipo
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, setFiltro, initForm, salvar, excluir, getLista, finalizar, reabrir, gerarComprovanteEntrega, gerarPackingList,
	setModoTelaItem, initFormItem, salvarItem, excluirItem, getListaItem, getListaHistorico,
	getListaFornecedor, getListaEmbalagem, getListaPlanoCarga, getListaEstoqueLocal, getListaSentido, getListaStatus, getListaCliente, getListaTransportadora, getListaEmbalagemViagemEventoTipo
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(EmbalagemViagem);
